import { GQL_ID } from '@@types'
import { generatePath } from 'react-router'

import { useFetchSingleCategory } from '@entities/Categories'
import { useFetchShopProducts } from '@entities/Product'

import { useAddressStore } from '@features/shipping-methods'

import { ProductCarousel } from '@widgets/product-carousel'



import { IMAGE_SIZES, URL_PAGE_CATALOG_1ST_LVL } from '@shared/contants'

type CategoryProductsCarouselProps = {
  categoryId?: GQL_ID;
}

export default function ProductsCategoryCarousel ({
  categoryId
}: CategoryProductsCarouselProps) {
  const { shopId } = useAddressStore()
  
  const { data: categoryData, loading: loadingCategory } = useFetchSingleCategory({
    id: categoryId,
    shop_id: shopId
  })
  
  const { data, loading } = useFetchShopProducts({
    shopId,
    categoryId,
    limit: 20,
    style: IMAGE_SIZES.LARGE,
    sort: {
      fieldName: 'default',
      direction: 1
    }
  })

  const products = data?.products?.edges ?? []

  const categoryLink = generatePath(URL_PAGE_CATALOG_1ST_LVL, {
    categorySlug: categoryData?.category?.slug ?? ''
  })

  return (
    <ProductCarousel
      link={categoryLink}
      title={categoryData?.category?.name ?? ''}
      products={products}
      loading={loading || loadingCategory}
    />
  )
}